// SS-1381: temporary V1/V2 split for demos. Remove with the V1 sunset.
import type { ItemUiVersion, MenuSection, UiVersion } from '@/types';

import { LOCAL_STORAGE_KEYS } from '@/constants/localStorage';

export const V1_UI_VERSION: UiVersion = 'v1';
export const V2_UI_VERSION: UiVersion = 'v2';

export const UI_VERSION_OPTIONS = [V1_UI_VERSION, V2_UI_VERSION].map(
  (version) => ({ value: version, label: version.toUpperCase() }),
);

export const readAdminUiVersion = (): UiVersion =>
  window.localStorage.getItem(LOCAL_STORAGE_KEYS.ADMIN_UI_VERSION) ===
  V2_UI_VERSION
    ? V2_UI_VERSION
    : V1_UI_VERSION;

// Without the V2 preview the choice is not the user's: V1 regardless of what storage holds.
export const resolveAdminUiVersion = (
  isV2PreviewAllowed: boolean,
): UiVersion => (isV2PreviewAllowed ? readAdminUiVersion() : V1_UI_VERSION);

export const storeAdminUiVersion = (version: UiVersion) => {
  window.localStorage.setItem(LOCAL_STORAGE_KEYS.ADMIN_UI_VERSION, version);
};

export const isVisibleInUiVersion = (
  itemVersion: ItemUiVersion | undefined,
  selected: UiVersion,
) =>
  itemVersion === undefined ||
  itemVersion === 'both' ||
  itemVersion === selected;

const sectionPrimaryHref = (nav: MenuSection['nav']) => {
  const item = nav[0];
  if (!item) return null;

  return 'submenu' in item ? (item.submenu[0]?.href ?? null) : item.href;
};

export const filterSectionsByUiVersion = (
  sections: MenuSection[],
  version: UiVersion,
): MenuSection[] =>
  sections
    .map((section) => {
      const nav = section.nav.flatMap((item): MenuSection['nav'] => {
        if (!isVisibleInUiVersion(item.version, version)) return [];
        if (!('submenu' in item)) return [item];

        const submenu = item.submenu.filter((subItem) =>
          isVisibleInUiVersion(subItem.version, version),
        );

        return submenu.length > 0 ? [{ ...item, submenu }] : [];
      });

      return { ...section, nav, primary_href: sectionPrimaryHref(nav) };
    })
    .filter((section) => section.nav.length > 0 || section.placeholder);
